import '../App.css';
import subQueryLogo from '../images/subquery/subquery-logo-light-text.svg';

function SubQuery() {
  return (
    <div className="project-page">
      <div className="project-hero">
        <a href="https://subquery.network" target="_blank" rel="noopener noreferrer">
          <img className="project-hero-logo" src={subQueryLogo} alt="SubQuery Network" />
        </a>
        <p className="project-hero-tagline">counterpoint are very proud to be participating in the SubQuery Network</p>
      </div>

      <div className="project-content container">

        <div className="project-card">
          <h3 className="project-card-title">Achievements</h3>
          <ul className="project-list">
            <li>Passed The <a href="https://doc.subquery.network/academy/herocourse/">Hero Course</a> in January 2022</li>
            <li>Frontier testnet season 2: finished in joint first position</li>
            <li><a href="https://explorer.subquery.network/subquery/subquery/leaderboard-s2">Subquery Network Leaderboard Season 2</a></li>
            <li>Frontier testnet season 3: finished in joint first position</li>
            <li><a href="https://explorer.subquery.network/subquery/subquery/subquery-network-leaderboard-season-3">Subquery Network Leaderboard Season 3</a></li>
            <li><a href="https://frontier.subquery.network/missions/ranks/indexer">Leaderboard Subquery Network Season 3</a></li>
            <li>Frontier indexer address: <code>0x82aADA6f7ADedC1B68bdFA40D09581d6bB65eF76</code></li>
            <li>2023-05-01 Built our Kepler indexer, the first step towards the decentralised mainnet</li>
            <li>2023-05-31 Opened <a href="https://kepler.subquery.network/indexer/0x82aADA6f7ADedC1B68bdFA40D09581d6bB65eF76">invited delegation on our Kepler indexer</a></li>
            <li>2024-02-23 Span up our <a href="https://app.subquery.network/indexer/0x82aADA6f7ADedC1B68bdFA40D09581d6bB65eF76">mainnet indexer</a> and started indexing mainnet projects</li>
          </ul>
        </div>

        <div className="project-card">
          <h3 className="project-card-title">Current status</h3>
          <ul className="project-list">
            <li>Actively operating our <a href="https://app.subquery.network/indexer/0x82aADA6f7ADedC1B68bdFA40D09581d6bB65eF76">mainnet indexer</a> and indexing live projects on the SubQuery Network</li>
          </ul>
        </div>

        <h2 className="project-section-heading">Why use counterpoint?</h2>

        <div className="project-card-grid">
          <div className="project-card">
            <h3 className="project-card-title">Experience</h3>
            <ul className="project-list">
              <li>20 years enterprise development experience with a focus on back-end processing and building performant database applications for high availability and throughput</li>
              <li>Active in the <a href="https://forum.subquery.network">SubQuery forum</a> and <a href="https://discord.gg/abum7WrFPv">Discord server</a> with a history of providing technical support and bug discovery/reporting</li>
              <li>Experience in other indexing protocols</li>
            </ul>
          </div>

          <div className="project-card">
            <h3 className="project-card-title">Infrastructure</h3>
            <ul className="project-list">
              <li>Multiple providers including Hetzner and Azure with servers throughout Europe for colocation and redundancy</li>
              <li>Carefully monitored infrastructure with headroom to handle whatever the query market demands</li>
            </ul>
          </div>

          <div className="project-card">
            <h3 className="project-card-title">SLA</h3>
            <ul className="project-list">
              <li>Hardware and software stack monitored with industry-leading tools</li>
              <li>Alerting via Discord and Telegram; consumers and delegators welcome to join</li>
              <li>Service-affecting alerts assessed and responded to within 1 hour between 09:00-23:00 UTC</li>
            </ul>
          </div>

          <div className="project-card">
            <h3 className="project-card-title">Historical performance</h3>
            <ul className="project-list">
              <li>Joint 1st position in 2 testnet seasons</li>
              <li>Committed to transparency; performance statistics published publicly, good and bad</li>
            </ul>
          </div>
        </div>

        <div className="project-card">
          <h3 className="project-card-title">Contact us</h3>
          <ul className="project-list">
            <li><a href="https://discord.gg/kxySShbevJ">Discord</a></li>
            <li><a href="mailto:info@counterpoint.software">Email</a></li>
            <li><a href="https://pacindexer.freecluster.eu">🥚 A little easter egg for reading this far :)</a></li>
          </ul>
        </div>

      </div>
    </div>
  );
}

export default SubQuery;
